export default "__VITE_ASSET__GYDee_gT__"